/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */
import type { LanguageRegistryResponse } from '../types';

import { axiosInstance } from '../../axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getLanguages = () => {
  /**
 * Return the full interview-language registry.

Unauthenticated: this is static, non-secret catalog data consumed by both the
authenticated admin settings UI and the unauthenticated candidate web-call page.
Cacheable for an hour since the registry only changes on deploy.
 * @summary Get Language Registry
 */
  const languagesGetLanguageRegistry = (
    options?: SecondParameter<typeof axiosInstance<LanguageRegistryResponse>>
  ) => {
    return axiosInstance<LanguageRegistryResponse>(
      { url: `/languages`, method: 'GET' },
      options
    );
  };
  return { languagesGetLanguageRegistry };
};
export type LanguagesGetLanguageRegistryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getLanguages>['languagesGetLanguageRegistry']>
  >
>;
